module.exports = __webpack_public_path__ + "static/media/icon-score-4-scale-4.15b09cb6.svg";